const { NODE_ENV } = process.env;
export const baseURL = NODE_ENV === 'development' ? 'http://127.0.0.1:1920' : '';
// 开发环境用空字符串，请求走同源由 devServer 代理到 192.168.124.18:8080；生产按需配置
export const pspBaseURL = NODE_ENV === 'development' ? '' : '';
// 全局请求前缀
export const apiPrefix = '/admin-imdt/api';
// 开发环境暂时用的本地联调，不需要psp前缀
export const pspApiPrefix = NODE_ENV === 'development' ? '/api' : '/psp/api';
export const onlyofficeApiPrefix = '/api'; // onlyoffice的api后端前缀特殊处理过，跟apiPrefix不一致
export const scope = 'zh-imdt';
export const appName = 'imdt-admin';
export const clientPrefix = '/backend';
export const isDev = NODE_ENV === 'development';
export const getTokenParams = {
  clientId: 'healthplus-oms',
  clientSecret: 'healthplus-oms',
  scope: 'zmn-rx-oms-server',
};
export const loginRememberKey = 'zk-hccm-w'; // 记住密码时保存数据的key
export const sendCodeTimeKey = 'zk-s-k'; // 记住密码时保存数据的key
export default {
  baseURL,
  getTokenParams,
};
